interface IParams<R> {
  setting?: string
  defaultValue: R
}

export const parseRawSetting = <R>({ setting, defaultValue }: IParams<R>): R => {
  try {
    if (!setting) {
      return defaultValue
    }

    return JSON.parse(setting)
  } catch (e) {
    return defaultValue
  }
}
